import File from "./File";

export default (isUpdate, sPage, sImages, sResearch) => ({
	maxImages: 10,
	maxResearch: 5,
	uploading: false,
	isUpdate: isUpdate,
	hasChanges: false,
	init() {
		if(sPage) {
			for (const key of Object.keys(this.form)) {
				this.form[key] = sPage[key]
			}

			// Special case name => title in kirby
			this.form.name = sPage.title
			
			// Special case teaching statements and other pronouns are named weirdly and Skye noticed too late
			this.form.placements = sPage.teaching
			this.form.altpronoun = sPage.altpronoun
			
			// Special case our page-based multiselects are weirdly encoded in kirby
			this.form.degree = `courses/${this.form.degree}`
			this.form.studio = `courses/${this.form.studio}`
			this.form.pronoun = `pronouns/${this.form.pronoun}`
			
			// Special case tags
			if (this.form.tags === '') {
				this.form.tags = []
			} else {
				this.form.tags = this.form.tags.split(', ')
			}
			
			// Special case bool
			this.form.videotop = this.form.videotop === 'true'
			
			// Init file uploads and sorting
			if (sImages.length !== 0) {
				this.images = [];
				for(const img of sImages) {
					this.images.push({
						content: img.src,
						caption: img.caption,
						filename: img.filename,
						iid: img.uuid,
						error: false,
						didChange: false
					});
				}
				if (this.images.length < this.maxImages) {
					this.images.push({
							iid: File.makeUUID(),
							content: '',
							filename: '',
							caption: '',
							didChange: false,
							error: false,
						})
				}
			}
			if (sResearch.length !== 0) {
				this.research = [];
				for(const img of sResearch) {
					this.research.push({
						content: img.src,
						caption: img.caption,
						filename: img.filename,
						iid: img.uuid,
						error: false,
						didChange: false
					});
				}
				if (this.research.length < this.maxResearch) {
					this.research.push({
							iid: File.makeUUID(),
							content: '',
							filename: '',
							caption: '',
							didChange: false,
							error: false,
						})
				}
			}
		}
		// Watchers for setting hasChanges
		const markChanges = (newVal, oldVal) => {
			this.hasChanges = true;
		}
		this.$watch('images', markChanges)
		this.$watch('research', markChanges)
		this.$watch('form', markChanges)
	},
	form: {
		pronoun: '',
		altpronoun: '',
		name: '',
		degree: '',
		studio: '',
		placements: '',
		email: '',
		website: '',
		instagram: '',
		statement: '',
		tags: [],
		project: '',
		firstvideo: '',
		firstvideocaption: '',
		secondvideo: '',
		seconvideocaption: '',
		thirdvideo: '',
		thirdvideocaption: '',
		videotop: false,
	},
	images: [
		{
			iid: 0,
			content: '',
			filename: '',
			didChange: false,
			error: false,
			caption: ''
		},
	],
	research: [
		{
			iid: 0,
			content: '',
			filename: '',
			didChange: false,
			error: false,
			caption: ''
		}
	],
	error: false,
	message: false,
	statementLimit: 1000,
	addPlaceholderToImages(section) {
		const images = section === 'images' ? this.images : this.research
		const limit =  section === 'images' ? this.maxImages : this.maxResearch
		let needsEmpty = images.length < limit
		let hasEmpty = false;
		for (const image of images) {
			if (image.content === '') {
				hasEmpty = true
			}
		}
		needsEmpty = needsEmpty && !hasEmpty;
		if (needsEmpty) {
			images.push({
					iid: File.makeUUID(),
					content: '',
					filename: '',
					didChange: false,
					error: false,
					caption: '',
				})
		}
	},
	wordLen: 150,
	checkWordLen(obj){
		var len = obj.value.split(/[\s]+/);
			if(len.length > wordLen){
					alert("You cannot put more than "+wordLen+" words in this text area.");
					obj.oldValue = obj.value!=obj.oldValue?obj.value:obj.oldValue;
					obj.value = obj.oldValue?obj.oldValue:"";
					return false;
			}
		return true;
	},
	get statementCounter() {
		if (this.form.statement) {
			const wordCount = this.form.statement.trim().split(/\s+/).filter(word => word.length > 0).length;
			return `${wordCount}/${this.statementLimit} words`;
		}
		return `0/${this.statementLimit} words`;
	}, 
	async submit() {
		// Validate statement word count before submission
		if (this.form.statement) {
			const wordCount = this.form.statement.trim().split(/\s+/).filter(word => word.length > 0).length;
			if (wordCount > this.statementLimit) {
				this.error = `Project statement cannot exceed ${this.statementLimit} words.`;
				return;
			}
		}
		
		// Just-in-case validation of all form fields
		let valid = true;
		for (const el of this.$el.querySelectorAll('input, select, textarea')) {
			valid = valid && el.reportValidity()
		}
		if (!valid) {
			this.error = "Please check that you have filled in all required fields and try again."
			return
		}
		let payload = this.form 
		payload.imageOrder = []
		
		// Upload all images 
		// We're uploading this 1 request/image to avoid straining the connection too much
		const uploads = []
		console.log(JSON.parse(JSON.stringify(this.images)))
		for (const image of this.images.filter((item) => { return item.didChange && item.content && item.content !== ''})) {
			uploads.push(this.submitSingleImage('images', image))
		}
		for (const image of this.research.filter((item) => { return item.didChange && item.content && item.content !== ''})) {
			uploads.push(this.submitSingleImage('research', image))
		}
		await Promise.all(uploads)
		
		// Sort images
		// Both, the image and the research fields, can be missing from the document.
		//  This is the case for students that haven't yet had their statement reviewed / on first upload
		payload.researchOrder = []
		const researchField = document.getElementById('files-research');
		if (researchField) {
			for(const item of researchField.children) {
				if (item.dataset.sortorder) {
					payload.researchOrder.push(item.dataset.sortorder)	
				}
			}
		}
		payload.imageOrder = []
		const imageField = document.getElementById('files-images')
		if (imageField) {
			for(const item of imageField.children) {
				if (item.dataset.sortorder) {
					payload.imageOrder.push(item.dataset.sortorder)	
				}
			}
		}

		// Actual submit
		const req = await fetch('/entry-api/upload', {
			method: 'post',
			body: JSON.stringify(this.form)
		})
		const res = await req.json()
		if (res.success) {
			// Not sure where to direct the people next?
			// Just showing an alert now
			this.message = 'Saved successfully.'
			this.hasChanges = false;
			this.uploading = false;
		} else {
			this.error = res.message
		}
	},
	async submitSingleImage(section, image) {
		const req = await fetch('/entry-api/upload-image', {
			method: 'post',
			body: JSON.stringify({image})
		})
		const res = await req.json()
		if (!res.success) {
			throw new Error("Failed to upload an image")
		}
		if (section === 'images') {
			for (const [index, iImage] of this.images.entries()) {
				if(iImage.iid === image.iid) {
					this.images[index].iid = res.id
				}
			}
		} else {
			for (const [index, iImage] of this.research.entries()) {
				if(iImage.iid === image.iid) {
					this.research[index].iid = res.id
				}
			}
		}
		await this.$nextTick()
	},
	async updateImage(event) {
		// Update the image
		if (event.detail.section === 'images') {
			this.images[event.detail.index] = event.detail.image
		} else {
			this.research[event.detail.index] = event.detail.image
		}
		this.addPlaceholderToImages(event.detail.section)
	},
	removeImage(event) {
		if (event.detail.section === 'images') {
			for (const image of this.images) {
				if(image.iid === event.detail.image) {
					this.images.splice(this.images.indexOf(image), 1)
				}
			}
		} else {
			for (const image of this.research) {
				if(image.iid === event.detail.image) {
					this.research.splice(this.research.indexOf(image), 1)
				}
			}
		}
		this.addPlaceholderToImages(event.detail.section)
	},
	async addMultiple(event) {
		if (event.detail.section === 'images') {
			let images = event.detail.images
			if (images.length + this.images.length > this.maxImages) {
				const d = images.length + this.images.length - this.maxImages
				images.splice(d*-1, d)
			}
			this.images = this.images.concat(images)
			this.addPlaceholderToImages('images')
		} else {
			let images = event.detail.images
			if (images.length + this.research.length > this.maxResearch) {
				const d = images.length + this.research.length - this.maxResearch
				images.splice(d*-1, d)
			}
			this.research = this.research.concat(images)
			this.addPlaceholderToImages('research')
		}
	},
	sortImage(section, item, position) {
		// We don't actuall respond here and instead just grab the correct sort-order from HTML when we save changes
		this.hasChanges = true
	},
	toggleTag(id) {
		if (!this.form.tags.includes(id)) {
			this.form.tags.push(id)
		} else {
			this.form.tags.splice(this.form.tags.indexOf(id), 1)
		}
	},
});
